import { twMerge } from "tailwind-merge";

type ClassValue = string | false | null | undefined;

/** Join class names, letting later Tailwind classes win. */
export function cn(...values: ClassValue[]): string {
  return twMerge(values.filter((v): v is string => typeof v === "string" && v !== "").join(" "));
}
